import React from 'react';

import { Card, CardBody, Grid, Typography } from '@gbm/queen-ui-guidelines';

import Navbar from 'components/Navbar';

export function ViewNoPermissions() {
  return (
    <>
      <Navbar title="Role-Based Permissions" />

      <Grid container className="mt-4" id="viewNoPermissions" data-testid="viewNoPermissions">
        <Grid row justify="center">
          <Grid md={8} lg={6} xl={5}>
            <Card>
              <CardBody className="p-5 text-center">
                <Typography component="h3">No tienes permisos para entrar a RBP</Typography>
                <Typography variant="textMuted">Contacta a un administrador para solicitar acceso.</Typography>
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ViewNoPermissions;
